module.exports = __webpack_public_path__ + "img/icici_logo2.c1d22151.png";